export default __webpack_public_path__ + "bml-wavesummitb1b5d6.jpg";